import { render, staticRenderFns } from "./LibraryIcon.vue?vue&type=template&id=13396e9a&"
import script from "./LibraryIcon.vue?vue&type=script&lang=js&"
export * from "./LibraryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports